export default __webpack_public_path__ + "static/media/img10.2a3259e8.jpg";